import { render, staticRenderFns } from "./TaskCreate.vue?vue&type=template&id=0f099435&scoped=true"
import script from "./TaskCreate.vue?vue&type=script&lang=ts"
export * from "./TaskCreate.vue?vue&type=script&lang=ts"
import style0 from "./TaskCreate.vue?vue&type=style&index=0&id=0f099435&prod&lang=scss&scoped=true"
import style1 from "./TaskCreate.vue?vue&type=style&index=1&id=0f099435&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f099435",
  null
  
)

export default component.exports